import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, Search, FolderKanban, Activity, Settings as SetIcon,
  LogOut, Database, TrendingUp, Compass, Inbox, Upload, BookOpen, FileText, Filter,
} from "lucide-react";
import api from "../api";

export default function Layout({ children }) {
  const navigate = useNavigate();
  const [inboundBadge, setInboundBadge] = useState(0);

  const logout = () => {
    localStorage.removeItem("mv_token");
    navigate("/login");
  };

  // Poll inbound pending count every 30s for sidebar badge
  useEffect(() => {
    let alive = true;
    const tick = async () => {
      try {
        const { data } = await api.get("/inbound/stats");
        if (!alive) return;
        const pending = (data?.by_status?.queued || 0) + (data?.by_status?.analyzing || 0);
        setInboundBadge(pending);
      } catch { /* silent */ }
    };
    tick();
    const id = setInterval(tick, 30000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  return (
    <div className="shell">
      <aside className="sidebar" data-testid="sidebar">
        <div className="sidebar-brand">
          <div className="mark">M</div>
          <div>
            <div>Max Valle</div>
            <div style={{fontSize:11,color:"var(--mv-text-muted)",fontWeight:500}}>LeadGen</div>
          </div>
        </div>

        <div className="sidebar-section-title">Operatività</div>
        <NavLink to="/" end className={({isActive}) => "sidebar-link " + (isActive ? "active" : "")} data-testid="nav-dashboard">
          <LayoutDashboard size={17} /> Dashboard
        </NavLink>
        <NavLink to="/ricerca" className={({isActive}) => "sidebar-link " + (isActive ? "active" : "")} data-testid="nav-search">
          <Search size={17} /> Ricerca aziende
        </NavLink>
        <NavLink to="/scopri" className={({isActive}) => "sidebar-link " + (isActive ? "active" : "")} data-testid="nav-discover">
          <Compass size={17} /> Scopri lead
        </NavLink>
        <NavLink to="/importa" className={({isActive}) => "sidebar-link " + (isActive ? "active" : "")} data-testid="nav-import">
          <Upload size={17} /> Importa lista
        </NavLink>
        <NavLink to="/lead-inbound" className={({isActive}) => "sidebar-link " + (isActive ? "active" : "")} data-testid="nav-lead-inbound">
          <Inbox size={17} /> Lead Inbound
          {inboundBadge > 0 && (
            <span data-testid="lead-inbound-badge" style={{
              marginLeft:"auto",
              background:"var(--mv-primary)", color:"#fff",
              fontSize:11, fontWeight:700,
              padding:"2px 8px", borderRadius:99, minWidth:20, textAlign:"center"
            }}>{inboundBadge}</span>
          )}
        </NavLink>
        <NavLink to="/forms" className={({isActive}) => "sidebar-link " + (isActive ? "active" : "")} data-testid="nav-forms">
          <FileText size={17} /> Form Builder
        </NavLink>
        <NavLink to="/crm" className={({isActive}) => "sidebar-link " + (isActive ? "active" : "")} data-testid="nav-crm">
          <Database size={17} /> CRM
        </NavLink>
        <NavLink to="/liste" className={({isActive}) => "sidebar-link " + (isActive ? "active" : "")} data-testid="nav-lists">
          <FolderKanban size={17} /> Liste lead
        </NavLink>
        <NavLink to="/coda" className={({isActive}) => "sidebar-link " + (isActive ? "active" : "")} data-testid="nav-queue">
          <Activity size={17} /> Coda analisi
        </NavLink>
        <NavLink to="/engagement" className={({isActive}) => "sidebar-link " + (isActive ? "active" : "")} data-testid="nav-engagement">
          <TrendingUp size={17} /> Engagement
        </NavLink>
        <NavLink to="/funnel" className={({isActive}) => "sidebar-link " + (isActive ? "active" : "")} data-testid="nav-funnel">
          <Filter size={17} /> Funnel
        </NavLink>

        <div className="sidebar-section-title">Configurazione</div>
        <NavLink to="/settings" className={({isActive}) => "sidebar-link " + (isActive ? "active" : "")} data-testid="nav-settings">
          <SetIcon size={17} /> Impostazioni
        </NavLink>
        <NavLink to="/spiegazioni" className={({isActive}) => "sidebar-link " + (isActive ? "active" : "")} data-testid="nav-explanations">
          <BookOpen size={17} /> Spiegazioni PDF
        </NavLink>
        <NavLink to="/catalogo-problemi" className={({isActive}) => "sidebar-link " + (isActive ? "active" : "")} data-testid="nav-problem-catalog">
          <BookOpen size={17} /> Catalogo problemi
        </NavLink>

        <div style={{flex:1}} />
        <button onClick={logout} className="sidebar-link" style={{border:"none",background:"transparent",textAlign:"left",width:"100%"}} data-testid="logout-btn">
          <LogOut size={17} /> Esci
        </button>
      </aside>
      <main className="main">{children}</main>
    </div>
  );
}
